export const services = {
  headers: {
    requestedService: "Servicio solicitado",
  },
  actions: {
    discardRequest: "Descartar solicitud",
  },
  storeInactiveTitle: "La tienda de servicios no está activa",
  storeInactiveDesc1:
    "Para recibir solicitudes de experiencias y servicios adicionales, necesitas activar tu tienda.",
  storeInactiveDesc2:
    "Una vez activada, tus huéspedes podrán solicitar servicios directamente desde su WhatsApp.",
  activateStoreBtn: "Activar tienda de servicios",

  noServicesDesc1:
    "Activa las Experiencias configurando tus servicios adicionales: desayuno, tour, transporte o lo que ofrezcas.",
  noServicesDesc2:
    "Tus huéspedes los verán justo después del check-in, directamente en su WhatsApp.",
  addFirstServiceBtn: "Agregar mi primera experiencia o servicio",
};
